import React, { useRef } from 'react'
import { Box, Modal } from '@maui/elements'
import ActorIcon from '../icons/ActorIcon'
import ModalDetails from '../details/ActorPageDetails/ModalDetails'
import { PageLoading } from '../common/PageLoading'
import { useActorHistoryQuery, useActorQuery } from '@nautilusjs/mati-apis'

function ActorModal({ id, name, ...modalProps }) {
  const { data: actorData, error, isLoading } = useActorQuery(id)
  const { data: actorHistory } = useActorHistoryQuery(id, { adapter: true })

  const modalBodyRef = useRef()

  return (
    <Modal {...modalProps} ariaHideApp={false}>
      <Modal.Header onClose={modalProps.onClose}>
        <ActorIcon height='24px' width='32px' actor={actorData} />
        <Modal.Title>{name}</Modal.Title>
      </Modal.Header>

      <Modal.Body backgroundColor="colorBackgroundSurface" ref={modalBodyRef} role="modal">
        {isLoading && <PageLoading/>}
        {!isLoading && actorData &&
          <ModalDetails id={id} actorData={actorData} actorHistory={actorHistory} />
        }
        {error && <Box height={250}>Error loading actor details</Box>}
      </Modal.Body>
    </Modal>
  )
}

export default ActorModal
